module.exports = __webpack_public_path__ + "components/Modals/SideDescription/img/map-icon.png?627a4725";


//////////////////
// WEBPACK FOOTER
// ./components/Modals/SideDescription/img/map-icon.png
// module id = 2372
// module chunks = 0